// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_int32 = require("rescript/lib/js/caml_int32.js");

function pctToNumOfSteps(pct, step) {
  return Caml_int32.div(pct * 100000 | 0, step);
}

function numOfStepsToPct(numOfSteps, step) {
  return Math.imul(numOfSteps, step) / 100000;
}

function progressTrackerMake(step, pctOpt, onProgress, dontDecreaseOpt) {
  var pct = pctOpt !== undefined ? pctOpt : 0;
  var dontDecrease = dontDecreaseOpt !== undefined ? dontDecreaseOpt : false;
  var step$1 = step * 100000 | 0;
  var numOfSteps = pctToNumOfSteps(pct, step$1);
  return {
          step: step$1,
          numOfSteps: numOfSteps,
          lastSentNumOfSteps: numOfSteps,
          onProgress: onProgress,
          dontDecrease: dontDecrease
        };
}

function progressTrackerSetCurrPct(state, curPct) {
  var onProgress = state.onProgress;
  if (onProgress === undefined) {
    return ;
  }
  var curNumOfSteps = pctToNumOfSteps(curPct, state.step);
  if (state.dontDecrease && curNumOfSteps > state.lastSentNumOfSteps || !state.dontDecrease && curNumOfSteps !== state.lastSentNumOfSteps) {
    onProgress(numOfStepsToPct(curNumOfSteps, state.step));
    state.lastSentNumOfSteps = curNumOfSteps;
    return ;
  }
  
}

function progressTrackerIntMake(step, cntOpt, maxCnt, onProgress, dontDecreaseOpt) {
  var cnt = cntOpt !== undefined ? cntOpt : 0;
  var dontDecrease = dontDecreaseOpt !== undefined ? dontDecreaseOpt : false;
  return {
          progressState: progressTrackerMake(step, cnt / maxCnt, onProgress, dontDecrease),
          cnt: cnt,
          maxCnt: maxCnt,
          stepInt: Math.max(maxCnt * step / 2 | 0, 1)
        };
}

function progressTrackerIntIncCnt(state) {
  state.cnt = state.cnt + 1 | 0;
  if (Caml_int32.mod_(state.cnt, state.stepInt) === 0) {
    return progressTrackerSetCurrPct(state.progressState, state.cnt / state.maxCnt);
  }
  
}

exports.progressTrackerMake = progressTrackerMake;
exports.progressTrackerSetCurrPct = progressTrackerSetCurrPct;
exports.progressTrackerIntMake = progressTrackerIntMake;
exports.progressTrackerIntIncCnt = progressTrackerIntIncCnt;
/* No side effect */
